const showFixedBanner = (): void => {
  const banner = document.querySelector('.p-fixedBanner') as HTMLElement;
  const footer = document.querySelector('.l-footer') as HTMLElement;
  if (!banner || !footer) return;

  // バナーの状態管理
  let isFooterVisible = false;

  // 初期状態で非表示
  banner.style.opacity = '0';
  banner.style.visibility = 'hidden';
  banner.style.transition =
    'opacity 0.3s ease-in-out, visibility 0.3s ease-in-out';

  // Intersection Observerの設定
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  };

  // バナーの表示制御
  const updateBannerVisibility = (show: boolean): void => {
    banner.style.opacity = show ? '1' : '0';
    banner.style.visibility = show ? 'visible' : 'hidden';
  };

  // スクロール位置に基づく表示判定
  const handleScroll = (): void => {
    const scrollPosition = window.scrollY;
    const scrollThreshold = window.innerHeight * 0.3; // ビューポートの30%をしきい値に

    if (isFooterVisible) {
      updateBannerVisibility(false);
      return;
    }

    if (scrollPosition > scrollThreshold) {
      updateBannerVisibility(true);
    } else {
      updateBannerVisibility(false);
    }
  };

  // フッターの可視性を監視
  const footerObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      isFooterVisible = entry.isIntersecting;
      handleScroll(); // フッターの状態が変わったら再判定
    });
  }, observerOptions);

  // フッターの監視を開始
  footerObserver.observe(footer);

  // スクロールイベントの監視を開始
  window.addEventListener('scroll', handleScroll);

  // 初期表示の判定
  handleScroll();
};

// DOMの読み込み完了時に実行
document.addEventListener('DOMContentLoaded', showFixedBanner);
